<template>
    <AppLayout>
        <div class="container mx-auto px-4">
            <div class="flex justify-center mt-16">
                <div class="w-full max-w-md">
                    <div class="bg-white rounded-lg shadow-md overflow-hidden">
                        <div
                            class="bg-gray-50 py-3 px-4 border-b border-gray-200"
                        >
                            <h2 class="text-lg font-medium text-gray-900">
                                {{ $t("messages.forgotPassword") }}
                            </h2>
                        </div>

                        <div class="p-6">
                            <p class="mb-4 text-sm text-gray-600">
                                {{ $t("messages.forgotPasswordDescription") }}
                            </p>

                            <div
                                v-if="status"
                                class="mb-4 p-3 bg-green-50 border border-green-200 rounded-md text-sm text-green-700"
                            >
                                {{ status }}
                            </div>

                            <form @submit.prevent="submit">
                                <div class="mb-4">
                                    <label
                                        for="email"
                                        class="block text-sm font-medium text-gray-700 mb-1"
                                    >
                                        {{ $t("messages.loginEmail") }}
                                    </label>
                                    <input
                                        id="email"
                                        type="email"
                                        v-model="form.email"
                                        class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-hidden focus:ring-blue-500 focus:border-blue-500"
                                        required
                                        autofocus
                                        autocomplete="email"
                                    />
                                    <div
                                        v-if="form.errors.email"
                                        class="mt-1 text-sm text-red-600"
                                    >
                                        {{ form.errors.email }}
                                    </div>
                                </div>

                                <button
                                    type="submit"
                                    class="w-full bg-blue-600 py-2 px-4 border border-transparent rounded-md shadow-xs text-sm font-medium text-white hover:bg-blue-700 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                                    :disabled="form.processing"
                                >
                                    {{ $t("messages.sendResetLink") }}
                                </button>
                            </form>

                            <div class="mt-4 text-center">
                                <Link
                                    :href="route('login')"
                                    class="text-sm text-blue-600 hover:text-blue-800"
                                >
                                    {{ $t("messages.backToLogin") }}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script setup>
import { Link, useForm } from '@inertiajs/vue3'
import AppLayout from '../../Layouts/AppLayout.vue'

defineProps({
    status: String,
})

const form = useForm({
    email: '',
})

const submit = () => {
    form.post(route('password.email'))
}
</script>
